import { createSelector } from 'reselect';
import { Selectors, State } from '@grandvisionhq/auth';
import { idleState } from '@grandvisionhq/state';
import { getMyAccount } from '../../selectors.js';

const getPrescriptions = createSelector(Selectors.getAuth, getMyAccount, (auth, myAccount)=>State.isLoggedIn(auth) ? myAccount.prescriptions : undefined
);
const getPrescriptionList = createSelector(getPrescriptions, (prescriptions)=>prescriptions ? prescriptions.list : undefined
);
const getPrescriptionListCall = createSelector(getPrescriptions, (prescriptions)=>prescriptions ? prescriptions.listCall : idleState()
);

export { getPrescriptionList, getPrescriptionListCall, getPrescriptions };
//# sourceMappingURL=selectors.js.map
